import Anchor from './Anchor';
import AnchorLink from './AnchorLink';
Anchor.Link = AnchorLink;
export default Anchor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/anchor/index.js
// module id = 576
// module chunks = 1